/* -----------------Helpers & Hooks--------------- */
import { useSearchContext } from "./contexts/SearchContext";
import { useSearchView } from "./hooks/useSearchView";

/* -----------------Types--------------- */
import type { FeedbackParams } from "../feedback/types";
import type { HandleTracking } from "../types";

import AssistantApplet from "@memorang/ui/src/components/AssistantApplet";
/* -----------------Child components--------------- */
import Container from "@memorang/ui/src/components/Container";
import { TTSContainer } from "../TTS";
type Props = {
	containerMaxWidth: "xs" | "sm" | "md" | "lg";
	handleTracking: HandleTracking;
	disableCustomResponse?: string;
	feedbackDialogParams?: FeedbackParams;
	loader?: React.ReactNode;
	handleNavigateToReference?: (url: string) => void;
	handleClose?: () => void;
	referenceThumbnails?: Record<string, string>;
	isItemAnswered?: boolean;
	font?: string;
	showPartnersSection?: boolean;
};

export const SearchOverlayBodyContainer = ({
	containerMaxWidth,
	feedbackDialogParams,
	handleTracking,
	loader,
	handleNavigateToReference,
	handleClose,
	referenceThumbnails,
	isItemAnswered,
	font,
	showPartnersSection,
}: Props) => {
	const {
		loading,
		streaming,
		messages,
		context,
		showReference,
		searchQuery,
		abortSearch,
		assistantInfo,
		isThreadLoading,
		vectorStoreParams,
	} = useSearchContext();

	const {
		handleSelectQuery,
		localRecommendedQueries,
		messageActions,
		appBarFeedbackAction,
		messageFeedbackComponents,
		isRecommendedQuestionsFetching,
		handleResetChatState,
		interceptSearchQuery,
		initialTitle,
	} = useSearchView({
		feedbackDialogParams,
		handleTracking,
	});

	const handleOverlayClose = () => {
		handleClose?.();
	};
	const textToSpeach = (_runId: string, content: string) => (
		<TTSContainer
			itemId={vectorStoreParams.itemId ?? ""}
			explanation={content}
			size={18}
			disabled={streaming}
		/>
	);
	const shouldScrollViewScrollToEnd =
		loading || streaming || isRecommendedQuestionsFetching || isThreadLoading;
	return (
		<>
			<Container
				containerStyle={{
					flex: 1,
				}}
				maxWidth={containerMaxWidth}
			>
				<AssistantApplet
					assistantInfo={assistantInfo}
					messages={messages}
					isRecommendedQuestionsFetching={isRecommendedQuestionsFetching}
					loading={loading}
					streaming={streaming}
					localRecommendedQueries={localRecommendedQueries}
					handleSelectQuery={handleSelectQuery}
					context={context}
					showReference={showReference}
					handleNavigateToReference={handleNavigateToReference}
					messageActions={messageActions}
					referenceThumbnails={referenceThumbnails}
					isThreadLoading={isThreadLoading}
					inputQuery={searchQuery.value}
					interceptSearchQuery={interceptSearchQuery}
					helperText={`${assistantInfo.alias} can make mistakes. Check important info.`}
					handleResetChatState={handleResetChatState}
					handleAbortSearch={abortSearch}
					messageFeedbackComponents={messageFeedbackComponents}
					handleOverlayClose={handleOverlayClose}
					isItemAnswered={isItemAnswered}
					initialTitle={initialTitle}
					appBarFeedbackAction={appBarFeedbackAction}
					shouldScrollViewScrollToEnd={shouldScrollViewScrollToEnd}
					textToSpeach={textToSpeach}
					loader={loader}
					font={font}
					showMemorangPoweredBy={showPartnersSection}
				/>
			</Container>
		</>
	);
};
